module.exports = __webpack_public_path__ + "static/media/nav-icon-projects.f3534c30.svg";